<template>
  <v-dialog v-model="show_helper_dialog" max-width="40%">
    <v-card class="pt-6">
      <v-card-title v-if="GETTERS_SHOW_HELPER_DIALOG_DATA.header.length > 0" class="headline"> {{ GETTERS_SHOW_HELPER_DIALOG_DATA.header }}
      </v-card-title>
      <v-card-text v-html="GETTERS_SHOW_HELPER_DIALOG_DATA.text">
      </v-card-text>


      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="show_helper_dialog = false">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'HelperDialog',

  data() {
    return {
      show_helper_dialog: false
    }
  },

  watch:{
    GETTERS_SHOW_HELPER_DIALOG(val) {
      if(val){
        this.show_helper_dialog = true
      }
    },

    show_helper_dialog(val){
      if(!val){
        this.close()
      }      
    }
 
  },

  methods: {
    ...mapMutations([
      'UPDATE_HELPER_DIALOG', 
    ]),

    close(){
      this.UPDATE_HELPER_DIALOG({
        'show' : false,
      })
    }

  },
  computed: {
    ...mapGetters([
      'GETTERS_SHOW_HELPER_DIALOG',
      'GETTERS_SHOW_HELPER_DIALOG_DATA',
    ]),
  },
};
</script>
